
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.idb-simple-columns {
  display:flex;
  width:-moz-fit-content;
  width:fit-content;
  flex-direction:column;
  gap:0.5rem;
  word-break:break-word;
}

  .idb-simple-columns.mobile-center {
  margin-left:auto;
  margin-right:auto;
}

  @media (min-width: 768px) {

  .idb-simple-columns.mobile-center {
    margin-left:0px;
    margin-right:0px;
  }
}

@media (min-width: 768px){
  .idb-simple-columns {
    display:grid;
  }
  .idb-simple-columns {
    width:100%;
  }
  .idb-simple-columns {
    justify-items:center;
  }
  .idb-simple-columns{
    grid-template-columns:var(--columns);
  }
}
`;